import React from "react";
import { FormItem as AntdFormItem } from "@formily/antd-v5";
import { connect, mapProps } from "@formily/react";
import { isVoidField } from "@formily/core";
import { RumbleLabel } from "./RumbleLabel"; // Import your custom label

// TODO - This is a temporary solution to use RumbleLabel in FormItem. It should be replaced with a more robust solution in the future.

// Extend the BaseItem to use RumbleLabel
const EnhancedBaseItem: React.FC<any> = (props) => {
  const { label, ...otherProps } = props;

  // Wrap the label with RumbleLabel if it exists
  const customLabel = label ? <RumbleLabel>{label}</RumbleLabel> : label;

  return <AntdFormItem.BaseItem {...otherProps} label={customLabel} />;
};

// Create the connected FormItem using the exact same mapProps as the original
export const RumbleFormItem = connect(
  EnhancedBaseItem,
  mapProps((props, field) => {
    if (isVoidField(field))
      return {
        label: field.title || props.label,
        asterisk: props.asterisk,
        extra: props.extra || field.description,
      };
    if (!field) return props;

    const takeFeedbackStatus = () => {
      if (field.validating) return "pending";
      return field.decoratorProps.feedbackStatus || field.validateStatus;
    };
    const takeMessage = () => {
      const split = (messages: any[]) => {
        return messages.reduce((buf, text, index) => {
          if (!text) return buf;
          return index < messages.length - 1
            ? buf.concat([text, ", "])
            : buf.concat([text]);
        }, []);
      };
      if (field.validating) return;
      if (props.feedbackText) return props.feedbackText;
      if (field.selfErrors.length) return split(field.selfErrors);
      if (field.selfWarnings.length) return split(field.selfWarnings);
      if (field.selfSuccesses.length) return split(field.selfSuccesses);
    };
    const takeAsterisk = () => {
      if (field.required && field.pattern !== "readPretty") {
        return true;
      }
      if ("asterisk" in props) {
        return props.asterisk;
      }
      return false;
    };
    return {
      label: props.label || field.title,
      feedbackStatus: takeFeedbackStatus(),
      feedbackText: takeMessage(),
      asterisk: takeAsterisk(),
      optionalMarkHidden:
        field.pattern === "readPretty" && !("asterisk" in props),
      extra: props.extra || field.description,
    };
  }),
);
